// extracted by mini-css-extract-plugin
export var closeButton = "_u-5";
export var container = "_u-0";
export var contentContainer = "_u-1";
export var desktop = "_u-2";
export var fullModalImage = "_u-6";
export var mobile = "_u-3";
export var withImage = "_u-4";